import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { Toaster } from '@/components/toast/Toaster';
import { LoadingState } from '@/components/PageState';
import { CookieConsentBanner } from '@/components/CookieConsentBanner';

import { useUiStore } from '@/core/ui/uiStore';

export function AppShell() {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  const setSidebarCollapsed = useUiStore((s) => s.setSidebarCollapsed);

  return (
    <div className="flex h-full">
      <Sidebar />

      {/* Mobile Backdrop overlay */}
      {!collapsed && (
        <div
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
          onClick={() => setSidebarCollapsed(true)}
        />
      )}

      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />
        <main className="flex-1 overflow-auto bg-fv-surfaceLow p-4 md:p-6">
          <Suspense fallback={<LoadingState />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
      <Toaster />
      <CookieConsentBanner />
    </div>
  );
}
